/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class CoordinateSystem.
* @enum {}
* @readonly
*/
export default class CoordinateSystem {
    
        /**
         * value: "geographic"
         * @const
         */
        "geographic" = "geographic";

    
        /**
         * value: "cartesian"
         * @const
         */
        "cartesian" = "cartesian";

    

    /**
    * Returns a <code>CoordinateSystem</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/CoordinateSystem} The enum <code>CoordinateSystem</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

